import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import './assets/css/style.css';

createApp(App)
    .use(router) // Ajout de Vue Router à l'application
    .mount('#app');